// extracted by mini-css-extract-plugin
export default {"video":"Video_video__L3ojW","shell":"Video_shell__e1awg","fills":"Video_fills__FXsyP","scrimmed":"Video_scrimmed__MiKk6","scrim":"Video_scrim__lUyW0","play":"Video_play__8YRuC"};